import React, { Fragment, useEffect, useState } from "react";
import Logo from "../../../Components/Logo";
import SpinnerButton from "../../../Components/SpinnerButton";
import "./styles.css";
import { persianArabicToEnglish } from "../../../Utils/UnicodeConvert";
import {
  getBusinessDetails,
  softPosInit,
} from "../../../Actions/DaapAppSoftPosActions/SoftPosActions";
import { toast } from "react-toastify";
import { useMask } from "@react-input/mask";
import {
  addCommas,
  removeCommas,
  removeNonNumeric,
  removeStringSpaces,
} from "../../../Utils/Helpers";

export const PaymentInfo = (props) => {
  const [loading, setLoading] = useState(false);
  const [cardNo, setCardNo] = useState("");
  const [amount, setAmount] = useState(null);
  const [business, setBusiness] = useState(null);

  const CardNumberInputRef = useMask({
    mask: "____ ____ ____ ____",
    replacement: { _: /\d/ },
  });

  const { business_id } = props.location.state || {};

  useEffect(() => {
    getBusinessDetails(business_id).then((res) => {
      setBusiness(res);
    });
  }, [business_id]);

  const onClickInit = () => {
    if (cardNo.length < 16) {
      return toast("شماره کارت الزامی است", { type: "error" });
    }
    if (!amount) {
      return toast("مبلغ الزامی است", { type: "error" });
    }
    if (cardNo.length >= 16) {
      setLoading(true);
      softPosInit({
        card_no: persianArabicToEnglish(removeStringSpaces(cardNo)),
        amount: Number(persianArabicToEnglish(removeCommas(amount))),
        business_id,
      })
        .then((response) => {
          if (response) {
            props.history.push({
              pathname: "/daapapp-softpos/payment",
              state: {
                result: {
                  cardNo: removeStringSpaces(cardNo),
                  total_amount: Number(
                    persianArabicToEnglish(removeCommas(amount)),
                  ),
                  business_id,
                },
                transactionId: response.transaction_id,
                clubId: response.club_id,
                business,
              },
            });
          }
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };

  return (
    <div className="sign-in">
      <Fragment>
        <Logo />
        <div className="d-flex justify-content-center mt-3">
          <h6>
            خرید از فروشگاه:{" "}
            <span className="payment-section-form-credit_blue">
              {business?.shop_name}
            </span>
          </h6>
        </div>
        <div className="sign-in-form">
          <p className="sign-in-form-p">
            شماره کارت<span className="sign-in-form-span">*</span>
          </p>
          <input
            className="sign-in-form-input"
            ref={CardNumberInputRef}
            onChange={(e) => setCardNo(e.target.value)}
            maxLength={20}
          />
          <p className="sign-in-form-p mt-3">
            مبلغ قابل پرداخت (تومان)<span className="sign-in-form-span">*</span>
          </p>
          <input
            className="sign-in-form-input"
            value={amount}
            onChange={(e) => {
              setAmount(addCommas(removeNonNumeric(e.target.value)));
            }}
            maxLength={11}
          />
          <SpinnerButton
            className="sign-in-form-btn mt-3"
            text="ادامه"
            onClick={onClickInit}
            loading={loading}
          />
        </div>
      </Fragment>
    </div>
  );
};
